<!-- Shop Selection -->
<div class="shop-selection-panel">
    <div class="shop-selection-header">Shop Selection</div>

    <div class="shop-search-row">
        <div class="custom-search-field">
            <input type="text" placeholder="Search..." [(ngModel)]="searchTerm" />
            <mat-icon>search</mat-icon>
        </div>
    </div>

    <div class="show-selected-row">
        <mat-checkbox [(ngModel)]="showSelectedOnly">Show selected shop only</mat-checkbox>
    </div>

    <div class="shop-tree">
        <ul class="tree-root">
            <li>
                <div class="tree-node">
                    <mat-icon class="toggle-icon" (click)="expandAllShops = !expandAllShops">
                        {{ expandAllShops ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                    <mat-checkbox [checked]="allShopsChecked" [indeterminate]="allShopsIndeterminate"
                        (change)="toggleAllShops($event)">
                        <strong>All Shops</strong> ({{ selectedAllShopsCount }}/{{ allShops.length }})
                    </mat-checkbox>
                </div>

                <ul *ngIf="expandAllShops" class="tree-children">
                    <li>
                        <div class="tree-node">
                            <mat-icon class="toggle-icon" (click)="expandSushiShops = !expandSushiShops">
                                {{ expandSushiShops ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                            <mat-checkbox [checked]="sushiShopsChecked" [indeterminate]="sushiShopsIndeterminate"
                                (change)="toggleSushiShops($event)">
                                Sushi Shops ({{ selectedSushiShopsCount }}/{{ sushiShops.length }})
                            </mat-checkbox>
                        </div>

                        <ul *ngIf="expandSushiShops" class="tree-children">
                            <li *ngFor="let shop of sushiShops">
                                <div class="tree-leaf">
                                    <mat-checkbox [checked]="shopChecked[shop.id]" (change)="toggleShop(shop, $event)">
                                        {{ shop.name }}
                                    </mat-checkbox>
                                </div>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <div class="tree-node">
                            <mat-icon class="toggle-icon" (click)="expandBentoShops = !expandBentoShops">
                                {{ expandBentoShops ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                            <mat-checkbox [checked]="bentoShopsChecked" [indeterminate]="bentoShopsIndeterminate"
                                (change)="toggleBentoShops($event)">
                                Bento Shops ({{ selectedBentoShopsCount }}/{{ bentoShops.length }})
                            </mat-checkbox>
                        </div>

                        <ul *ngIf="expandBentoShops" class="tree-children">
                            <li *ngFor="let shop of bentoShops">
                                <div class="tree-leaf">
                                    <mat-checkbox [checked]="shopChecked[shop.id]" (change)="toggleShop(shop, $event)">
                                        {{ shop.name }}
                                    </mat-checkbox>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>

    <div class="shop-selection-footer">
        Selected: {{ selectedShops.length }} Shop{{ selectedShops.length === 1 ? '' : 's' }}
        <span *ngIf="selectedShopTypes.length"> ({{ selectedShopTypes.join(', ') }})</span>
    </div>
</div>